import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { Quote } from '@/types';
import { GhostQuoteBadge } from './QuoteBadges';
import { hasOutdatedRows, isNeverOpened } from './quoteSignals';

/**
 * De signalen naast de status. `compact` gebruikt kortere teksten voor de
 * kaartweergave, waar de badge naast de status op één regel moet passen —
 * anders schuiven de titels binnen een rij kaarten uit elkaar.
 *
 * Alles wat met ondertekenen te maken heeft — ook 'UBO moet nog tekenen' —
 * staat in QuoteSignatureStatus, zodat die vraag overal op één plek hangt.
 */
export function QuoteSignalBadges({
  quote,
  compact = false,
  className,
}: {
  quote: Quote;
  compact?: boolean;
  className?: string;
}) {
  const outdatedRows = quote.outdatedProductRows ?? 0;
  const showNeverOpened = isNeverOpened(quote);
  const showOutdated = hasOutdatedRows(quote);

  if (!quote.isGhost && !showNeverOpened && !showOutdated) return null;

  return (
    <div className={cn('flex flex-wrap items-center gap-1.5', className)}>
      <GhostQuoteBadge quote={quote} />
      {showNeverOpened && (
        <Badge variant="warning" className="whitespace-nowrap" title="Verstuurd, maar nog niet door de klant geopend">
          Nooit geopend
        </Badge>
      )}
      {showOutdated && (
        <Badge
          variant="secondary"
          className="whitespace-nowrap"
          title="Bevat regels op een oudere productversie"
        >
          {compact
            ? `${outdatedRows}× oude versie`
            : `${outdatedRows} regel${outdatedRows === 1 ? '' : 's'} op oude versie`}
        </Badge>
      )}
    </div>
  );
}

export default QuoteSignalBadges;
